import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/gruh-udhyog/products";

export const Route = createFileRoute("/admin/_modules/_gruh-udhyog/products")({
  component: Page,
});
